import { render, staticRenderFns } from "./outBoundList.vue?vue&type=template&id=2aa22954&scoped=true&"
import script from "./outBoundList.vue?vue&type=script&lang=js&"
export * from "./outBoundList.vue?vue&type=script&lang=js&"
import style0 from "./outBoundList.vue?vue&type=style&index=0&id=2aa22954&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa22954",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aa22954')) {
      api.createRecord('2aa22954', component.options)
    } else {
      api.reload('2aa22954', component.options)
    }
    module.hot.accept("./outBoundList.vue?vue&type=template&id=2aa22954&scoped=true&", function () {
      api.rerender('2aa22954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/factory/outBound/outBoundList.vue"
export default component.exports